import { render, staticRenderFns } from "./RenumberVatsModal.vue?vue&type=template&id=0f825f0a&"
import script from "./RenumberVatsModal.vue?vue&type=script&lang=ts&"
export * from "./RenumberVatsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports